<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items" :search="search">
        <template v-slot:top>
          <v-toolbar elevation="0">
            <v-toolbar-title>Carteras</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-file-input
              v-model="items_add_file_excel"
              label="Excel base de datos"
              multiple
              outlined
              dense
              hide-details
              @change="cargarExcel()"
            ></v-file-input>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Buscar"
              outlined
              dense
              hide-details
            ></v-text-field>
            <v-divider vertical class="mx-3"></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="nuevaCartera()">Nuevo</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="editarCartera(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Inicio vigencia", value: "inicio_vigencia" },
      { text: "Fin vigencia", value: "fin_vigencia" },
      { text: "Placa", value: "placa" },
      { text: "Marca", value: "marca" },
      { text: "Modelo", value: "modelo" },
      { text: "color", value: "color" },
      { text: "Estado", value: "estado" },
      { text: "Editar", value: "editar" },
    ],
    items: [],
    items_add_file_excel: [],
    dialog: false,
    id_cartera: 0,
    cartera_nombre: "",
    flag: 1,
  }),
  created() {
    //
  },
  methods: {
    listar() {
      axios.get("api/Carteras/Listar").then((response) => {
        this.items = response.data;
      });
    },
    nuevaCartera() {
      this.flag = 1;
      this.dialog = true;
    },
    crearCartera() {
      axios
        .post("api/Carteras/Crear", {
          nombre: this.cartera_nombre,
        })
        .then(() => {
          this.listar();
          this.cerrarDialog();
        });
    },
    actualizarCartera() {
      axios
        .put("api/Carteras/Actualizar", {
          id_carteras: this.id_cartera,
          nombre: this.cartera_nombre,
        })
        .then(() => {
          this.cerrarDialog();
          this.listar();
        });
    },
    editarCartera(item) {
      //console.log(item);
      this.flag = 2;

      this.id_cartera = item.id_carteras;
      this.cartera_nombre = item.nombre;

      this.dialog = true;
    },
    cerrarDialog() {
      this.dialog = false;

      this.cartera_nombre = "";
    },
    cargarExcel() {
      console.log(this.items_add_file_excel);
    },
  },
};
</script>